/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 * File Path: packages/sharedlib/src/actions/linear.actions.ts
 */

import { goto } from '$app/navigation';
import { get } from 'svelte/store';
import type { ExportToLinearRequest, ExportToLinearResponse } from '@repo/common/types/Linear';
import { getPrivateClient } from '../data/common.data';
import { userAuthStore } from '../stores/auth.store';
import { getHandlerAsync } from '../sharedlib';
import constants from '../utils/constants';

function getLinearAuthUrl(): string {
	const endpoint = constants.VITE_VERCEL_URL
		? `${constants.VITE_VERCEL_URL.includes('localhost') || constants.VITE_VERCEL_URL.includes('192') ? 'http' : 'https'}://${constants.VITE_VERCEL_URL}`
		: constants.API_SCHEME_HOST;

	return `${endpoint}/tracker/linear/redirect`;
}

export async function openConnectLinear(): Promise<void> {
	const authUrl = getLinearAuthUrl();

	if (constants.IS_DESKTOP) {
		const handler = await getHandlerAsync();
		handler.openLink(authUrl);
		return;
	}

	if (authUrl.startsWith(constants.API_SCHEME_HOST)) {
		await goto('/tracker/linear/redirect');
		return;
	}

	window.location.href = authUrl;
}

export async function exportTasksToLinear(
	request: ExportToLinearRequest
): Promise<ExportToLinearResponse> {
	const authToken = get(userAuthStore);
	const client = getPrivateClient(authToken, { timeout: 10000, retries: 2 });
	const response = await client.post('/tracker/linear/issues', request);
	return response.data as ExportToLinearResponse;
}
